import debounce from 'lodash/debounce';
import { Input } from 'antd';
import React, { useCallback, useMemo } from 'react';
export const PopoverSelectorSearch = ({ onSearch, placeholder }) => {
    const debouncedChange = useMemo(() => debounce((event) => {
        if (onSearch) {
            onSearch(event.target.value);
        }
    }, 750), [onSearch]);
    const handleChange = useCallback((e) => {
        e.persist();
        debouncedChange(e);
    }, [debouncedChange]);
    return (React.createElement(Input.Search, { allowClear: true, className: 'popover-search', enterButton: true, onChange: handleChange, placeholder: placeholder }));
};
